
  let lastScrollTop = 0;
  const navbar = document.querySelector('.navbar');
  const filterNav = document.querySelector('.filter-nav');

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Aktifkan hanya untuk layar < 1152px
    if (window.innerWidth < 1152) {
      if (currentScroll > lastScrollTop) {
        // Scroll down
        navbar.classList.add('hide');
        filterNav.classList.add('hide');
      } else {
        // Scroll up
        navbar.classList.remove('hide');
        filterNav.classList.remove('hide');
      }
    } else {
      // Reset class jika layar besar
      navbar.classList.remove('hide');
      filterNav.classList.remove('hide');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });